module.exports = __webpack_public_path__ + "static/media/logo_segline.2469e588.svg";